import { render, staticRenderFns } from "./MyCstmrRegResult.vue?vue&type=template&id=725f59cf&"
import script from "./MyCstmrRegResult.vue?vue&type=script&lang=js&"
export * from "./MyCstmrRegResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports